import Header from "../../../sections/Header/Header";
import React from "react";
import Trial from "../../../sections/Bookfreetrial/Trial";
import Footer from "../../../sections/Footer/Footer";
import CoursesPicContLTQ from "../../../sections/TitleBgCourses/CoursesPicContLTQ/CoursesPicContLTQ";
import TitleBgCoursesLTQ from "../../../sections/TitleBgCourses/TitlepicCourses/TitleBgCoursesLTQ/TitleBgCoursesLTQ";

const CoursesLTQ =()=>{
    return(
        <div>
            <Header/>
            <TitleBgCoursesLTQ/>
            <CoursesPicContLTQ/>
         
            <Trial/>
            <Footer/>
        </div>
    )
}
export default CoursesLTQ;